export default __webpack_public_path__ + "static/media/image17.3c7cdc01.jpg";